module.exports = __webpack_public_path__ + "img/edit_Pencil.5081017e.svg";